<span class="material-symbols-outlined dialog__icon">cancel</span>
<h2 mat-dialog-title>ACCEPT BOOKING</h2>
<mat-dialog-content>
    <p>Are you sure you want to accept this booking?</p>
    <p>This may not be your next booking.</p>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row w-100 mx-0 g-3">
        <div class="col-12">
            <button mat-flat-button class="w-100" color="primary" mat-dialog-close [mat-dialog-close]="true"
                cdkFocusInitial>ACCEPT BOOKING</button>

        </div>
        <div class="col-12">
            <button mat-button class="w-100" color="warn" mat-dialog-close cdkFocusInitial>CANCEL</button>

        </div>
    </div>
</mat-dialog-actions>